<div fxLayout="column" fxLayoutAlign="center center" class="content-header bg-primary p-5" [class.has-bg-image]="settings.hasBgImage">
    <img *ngIf="image" [src]="image" alt="Alfonso Pardo" class="mb-2">
    <mat-icon *ngIf="icon" class="mat-icon-xlg">{{icon}}</mat-icon>
    <h1 *ngIf="headerTitle">{{headerTitle}}</h1>
    <h4 *ngIf="desc" class="lighter-color mt-2">{{desc}}</h4>
    <h4 *ngIf="desc1" class="lighter-color mt-2">{{desc1}}</h4>
</div>